<div class="flex-table-page">
<div class="px-6 pt-6 flex-table-header">
  <h2 class="text-2xl font-semibold text-gray-800">
    {{ "e_invoice.provider.title" | translate }}
  </h2>
</div>
<div class="px-6 py-4 flex flex-col flex-1 min-h-0">
  <!-- Search Form -->
  <app-search-form
    data-testid="e-invoice-provider-search-form"
    [searchFormat]="searchFormConfig"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions">
      <app-status-filter
        data-testid="e-invoice-provider-status-filter"
        [primaryButton]="primaryButton"
        [secondaryButton]="secondaryButton"
        (primaryButtonClick)="onAdd()"
        (secondaryButtonClick)="onColumnConfigClick($event)"
      ></app-status-filter>
    </div>
  </app-search-form>

  <!-- Data Table -->
  <div class="flex-table-section">
    <advanced-data-table
      data-testid="e-invoice-provider-table"
      #advancedTable
      [dataSource]="dataSource()"
      [defaultColumns]="defaultColumns"
      [flexibleColumns]="flexibleColumns"
      [rows]="rows"
      [first]="first"
      [totalRecords]="totalRecords()"
      [loading]="loading()"
      [showInternalColumnConfigButton]="false"
      scrollHeight="flex"
      (pageChange)="onPageChange($event)"
    >
    <!-- Custom Template for Status Column -->
    <ng-template
      #customTemplate
      let-value
      let-column="column"
      let-rowData="rowData"
    >
      @if (column?.prop === "status") {
        <div class="flex items-center justify-center gap-1 w-full">
          <p-tag
            [attr.data-testid]="'e-invoice-provider-status-tag-' + rowData.id"
            [value]="getStatusDisplayText(value)"
            [severity]="getStatusSeverity(value)"
            styleClass="status-tag"
          />
        </div>
      }
    </ng-template>

    <!-- Custom Actions Template -->
    <ng-template #actionsTemplate let-rowData>
      <div class="flex items-center justify-center gap-2">
        <!-- <button
          type="button"
          (click)="onView(rowData)"
          class="action-link action-view cursor-pointer"
        >
          {{ "common.actions.view" | translate }}
        </button> -->
        @if (canUpdate()) {
          <button
            [attr.data-testid]="'e-invoice-provider-action-edit-' + rowData.id"
            type="button"
            (click)="onEdit(rowData)"
            class="action-link action-edit cursor-pointer"
          >
            {{ "common.actions.edit" | translate }}
          </button>
        }
        @if (canUpdate()) {
          <button
            [attr.data-testid]="
              'e-invoice-provider-action-' +
              (rowData.status ? 'deactivate' : 'activate') +
              '-' +
              rowData.id
            "
            type="button"
            (click)="onStatusChange(rowData, !rowData.status)"
            class="action-link cursor-pointer"
            [class]="rowData.status ? 'action-disable' : 'action-enable'"
          >
            {{
              rowData.status
                ? ("common.table.actions.deactivate" | translate)
                : ("common.table.actions.activate" | translate)
            }}
          </button>
        }

        <!-- <button
          type="button"
          (click)="onDelete(rowData)"
          class="action-link action-delete cursor-pointer"
        >
          {{ "common.actions.delete" | translate }}
        </button> -->
      </div>
    </ng-template>
    </advanced-data-table>
  </div>
</div>
</div>

<!-- Toast Messages -->
<p-toast data-testid="e-invoice-provider-toast"></p-toast>

<!-- Confirmation Dialog -->
<app-confirmation-dialog
  data-testid="e-invoice-provider-confirmation-dialog"
  [(visible)]="showConfirmationDialog"
  [title]="confirmationTitle()"
  [message]="confirmationMessage()"
  [buttons]="confirmationButtons()"
  (emitOnClick)="onConfirmationDialogAction($event)"
></app-confirmation-dialog>
